<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-09-02 14:21:51
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="permission">
    <el-form ref="form" :model="form" label-width="140px">
      <el-form-item label="在线订单:" @change="is_order">
        <el-radio-group v-model="form.order_on_off">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
        <span class='tips' style='margin-left:15px;'>关闭后所有角色无法使用功能，系统也不再计算订单返佣</span>
      </el-form-item>
      <div class="is_order" v-if="form.order_on_off">
        <el-form-item label="收货期限:">
          <el-row>
            <el-col :span="1" style="text-align:right">超过</el-col>
            <el-col :span="2">
              <el-input v-model="form.auto_receiving_days"  placeholder></el-input>
            </el-col>天后自动确认收货  <span class='tips'>最小设置0，设置0代表总部或上级发货后订单状态即直接变为已完成，无需手动确认收货</span>
          </el-row>
        </el-form-item>
        <el-form-item label="订单模式:">
          <el-radio-group v-model="form.order_model"  @change='changes("order_model")'>
            <el-radio :label="1">逐级发货</el-radio>
            <el-radio :label="2">总部统一发货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label v-if="form.order_model=='1'">
          <div class="tipsBox">
            <h6>逐级发货</h6>经销商或门店在线下单后默认提交给直属上级或所属经销商审核并发货
          </div>
        </el-form-item>
        <el-form-item label v-if="form.order_model=='2'">
          <div class="tipsBox">
            <h6>总部统一发货</h6>经销商或门店在线下单后由总部统一进行审核发货，过了退货有效期之后再根据各级的订货价按差价返利给对应直属上级
          </div>
          <el-form-item label="订单返利:">
            <el-radio-group v-model="form.order_rebate_on_off" style="margin-right:20px;">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
            <el-tooltip class="item" effect="light" :content="content" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
            <el-form-item label="返利期限:" v-if="form.order_rebate_on_off=='1'">
              <el-row>
                <el-col :span="2" style="text-align:right;margin-right:5px;">确认收货</el-col>
                <el-col :span="2" style="margin-right:5px;">
                  <el-input v-model="form.order_rebate_days" placeholder></el-input>
                </el-col>天后进行返利
                <span class="tips">(最小设置0，设置0代表收货后立刻返利)</span>
              </el-row>
              <el-form-item class="error">温馨提示：返利后即使产生退货返利也不会退还，如需退货可逐级往上退，再让上级线下退款</el-form-item>
            </el-form-item>
          </el-form-item>
        </el-form-item>
        <el-form-item label="订单权限:">
          <span class="tips">提示：选中对应的客户类型后，该客户类型才拥有在线下单的功能</span>
        </el-form-item>
        <el-form-item label>
          <el-form-item label>
            <el-row>
              <el-col :span="6">
                <el-checkbox-group v-model="form.order_directly_dealer" @change='changes("order_directly_dealer")'>
                  <el-checkbox :label="String(1)" name="directlyUse" @change="$forceUpdate()"> 允许【直属经销商】使用在线订单功能</el-checkbox>
                </el-checkbox-group>
              </el-col>
              <el-col :span="10">
                <el-form-item label="订单支付方式支持:">
                  <el-checkbox-group v-model="form.order_directly_dealer_pay_type">
                    <el-checkbox :label="String(1)" name="directlyWay" :disabled='!form.order_directly_dealer&&form.order_directly_dealer!=1'>线下支付</el-checkbox>
                    <el-checkbox :label="String(2)" name="directlyWay" :disabled='!form.order_directly_dealer&&form.order_directly_dealer!=1'> 微信支付</el-checkbox>
                    <el-checkbox :label="String(3)" name="directlyWay" :disabled='!form.order_directly_dealer&&form.order_directly_dealer!=1'> 扫码支付</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form.order_directly_dealer==1||form.order_directly_dealer">
              <el-col :offset="1" :span="5">
                <el-checkbox-group v-model="form.order_price_directly_dealer" >
                  <el-checkbox :label="String(1)" name="type">允许【直属经销商】使用订货价管理功能</el-checkbox>
                </el-checkbox-group>
              </el-col>
              <el-col :span="9">
                <span class="tips">（勾选后【直属经销商】可自定义下级经销商或直属门店的订货价)</span>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-checkbox-group v-model="form.order_directly_shop" @change='changes("order_directly_shop")'>
                  <el-checkbox :label="String(1)" name="type">允许【直属门店】使用在线订单功能</el-checkbox>
                </el-checkbox-group>
              </el-col>
              <el-col :span="10">
                <el-form-item label="订单支付方式支持:">
                  <el-checkbox-group v-model="form.order_directly_shop_pay_type">
                    <el-checkbox :label="String(1)" name="directlyStoreWay" :disabled='!form.order_directly_shop&&form.order_directly_shop!=1'>线下支付</el-checkbox>
                    <el-checkbox :label="String(2)" name="directlyStoreWay" :disabled='!form.order_directly_shop&&form.order_directly_shop!=1'>微信支付</el-checkbox>
                    <el-checkbox :label="String(3)" name="directlyStoreWay" :disabled='!form.order_directly_shop&&form.order_directly_shop!=1'>扫码支付</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-checkbox-group v-model="form.order_not_directly_dealer" @change='changes("order_not_directly_dealer")'>
                  <el-checkbox :label="String(1)" name="type">允许【非直属经销商】使用在线订单功能</el-checkbox>
                </el-checkbox-group>
              </el-col>
              <el-col :span="10">
                <el-form-item label="订单支付方式支持:">
                  <el-checkbox-group v-model="form.order_not_directly_dealer_pay_type">
                    <el-checkbox :label="String(1)" name="undirectlyWay"  :disabled='!form.order_not_directly_dealer&&form.order_not_directly_dealer!=1'>线下支付</el-checkbox>
                    <el-checkbox :label="String(2)" name="undirectlyWay"  :disabled='(!form.order_not_directly_dealer&&form.order_not_directly_dealer!=1)||form.order_model==1'>微信支付</el-checkbox>
                    <el-checkbox :label="String(3)" name="undirectlyWay"  :disabled='(!form.order_not_directly_dealer&&form.order_not_directly_dealer!=1)||form.order_model==1'>扫码支付</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="form.order_not_directly_dealer">
              <el-col :offset="1" :span="5">
                <el-checkbox-group v-model="form.order_price_not_directly_dealer">
                  <el-checkbox :label="String(1)" name="undirectlyManage">允许【非直属经销商】使用订货价管理功能</el-checkbox>
                </el-checkbox-group>
              </el-col>
              <el-col :span="9">
                <span class="tips">（勾选后【非直属经销商】可自定义下级经销商或直属门店的订货价)</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
            
                <el-checkbox-group v-model="form.order_not_directly_shop" @change='changes("order_not_directly_shop")'>
                  <el-checkbox :label="String(1)" name="type">允许【非直属门店】使用在线订单功能</el-checkbox>
                </el-checkbox-group>
              </el-col>
              <el-col :span="10">
               
                <el-form-item label="订单支付方式支持:" >
                  <el-checkbox-group v-model="form.order_not_directly_shop_pay_type" >
                    {{form.order_model}}
                    <el-checkbox :label="String(1)" name="undirectlyStoreWay" :disabled='!form.order_not_directly_shop&&form.order_not_directly_shop!=1'>线下支付</el-checkbox>
                    <el-checkbox :label="String(2)" name="undirectlyStoreWay" :disabled='(!form.order_not_directly_shop&&form.order_not_directly_shop!=1)||form.order_model==1'>微信支付</el-checkbox>
                    <el-checkbox :label="String(3)" name="undirectlyStoreWay" :disabled='(!form.order_not_directly_shop&&form.order_not_directly_shop!=1)||form.order_model==1'>扫码支付</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
               
                <el-checkbox-group v-model="form.order_staff">
                  <el-checkbox :label='String(1) '    name="type">允许以下员工类型代自己管理区域内的门店下单</el-checkbox>
                </el-checkbox-group>
              </el-col>
              <el-col :span="9">
                <span class="tips">（订单支付方式继承门店支付方式）</span>
              </el-col>
              <el-col :offset="1" v-if="form.order_staff">
                <el-form-item label>
                  <el-checkbox-group v-model="form.order_staff_types">
                    <el-checkbox :label="String(v.id)" name="staffType" v-for="(v,k) in StaffType" :key='k'>{{v.type_name}}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="商品属性控制:">
          <el-col :span="3">
            <el-radio-group v-model="form.product_attribute_on_off">
              <el-radio :label="1" name="ProductAttributes">开启</el-radio>
              <el-radio :label="0" name="ProductAttributes">关闭</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="21">
            <span class="tips">启用后,上架商品时区分商品属性，同一个商品可设置不同的商品属性不同的价格</span>
          </el-col>
        </el-form-item>
     
        <el-form-item label v-if="form.product_attribute_on_off==1">
          <el-form-item label>
            <div class="product">
              <el-button type="primary" @click="dialogVisible=!dialogVisible,type='add'">添加商品属性</el-button>
              <ul>
                <li class="clearfix" v-for="(v,k) in attributeList" :key="k">
                  <div class="fl">
                    <span style="margin-right:15px">{{v.attribute_id}}</span>
                    <span>{{v.attribute_name}}</span>
                  </div>
                  <div class="fr">
                  <el-button  type="text" @click='editAttr(v)'>修改</el-button>

                  <el-button  type="text" @click='delAttr(v)' v-if='v.is_default==0'>删除</el-button>
                    <a style="margin-right:5px;margin-left:6px"    href="javascript:;" v-if='v.is_default==1'>删除</a>

                  </div>
                </li>
              </ul>
            </div>
          </el-form-item>
        </el-form-item>
      </div>
      <div class="foot">
        <el-button type="primary" @click='save'>保存</el-button>
      </div>
    </el-form>
    <el-dialog title="添加" :visible.sync="dialogVisible" width="30%" >
    <div class="btnBox">
                      
                        商品属性名称:<el-input  label="" v-model="attribute_name" class="threeLeve" maxlength="6" style="width:250px"></el-input>({{attribute_name.length}}/6)
                        <br/>
           <el-button style='margin-top:20px;' type="primary" @click="saveAttr()">保存</el-button>
    </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "order",
  data() {
    return {
      dialogVisible: false,
      form: {
        type: [],
        order_on_off: 0, //是否开启在线订单
        auto_receiving_days: 0, //收货期限
        order_model: "逐级发货", //订单模式
        order_rebate_on_off: 1, //订单返利
        order_rebate_days: 0, //返利期限
        order_directly_dealer: 0, //允许直营经销商使用
        order_directly_dealer_pay_type: [], //直营经销商付款方式
        order_price_directly_dealer: 0, //直营经销商订货价管理
        order_directly_shop: 0, //允许直营门店 使用
        directlyStoreWay: [], //直营门店支付方式
        undirectly:0, //允许非直营经销商使用
        order_directly_shop_pay_type: [], //允许非直营经销商付款方式
        undirectlyManage: 0, //非直营经销商订货价管理
        order_not_directly_shop: 0, //允许非直营门店 使用
        order_not_directly_shop_pay_type: [], //非直营门店支付方式
        order_staff: 0, //允许员工
        order_staff_types: [], //员工类型
        product_attribute_on_off: 0 //是否开启商品属性
      },
      input: "",
      attributeList:[],//商品属性
      attribute_name:'',//商品属性名
      attribute_id:"",//商品属性ID
      StaffType:[{staff_type:0}],//员工类型列表
      content:
        "返利根据订货经销商的订货价与直属上级经销商的订货价之间的差价进行计算,并且返利会逐级往上返,直到上级为总部为止,但如果直属上级的订货价大于或等于订货经销商的订货价时,则不返利"
    };
  },
  methods: {
    is_order() {
  
    },
    init(){
          this.getAttribute()

      this.$get('logistics','/configs.order').then(res=>{
     
        this.form=res.data
        // 过滤 数据  1=>true
           for (const key in this.form) {
        if (this.form.hasOwnProperty(key)) {
      
          if(this.form[key]===1&&(key=='order_directly_dealer'||key=='order_directly_shop'||key=='order_price_not_directly_dealer'||key=='order_not_directly_dealer'||key=='order_not_directly_shop'||key=='order_staff'||key=='order_price_directly_dealer')){
             this.form[key]=true
          }else  if(this.form[key]===0&&(key=='order_directly_dealer'||key=='order_directly_shop'||key=='order_price_not_directly_dealer'||key=='order_not_directly_dealer'||key=='order_not_directly_shop'||key=='order_staff'||key=='order_price_directly_dealer')) {
            this.form[key]=false
          }else{
            this.form[key]=this.form[key]
          }
        }
      }
        if(res.data.product_attribute_on_off==1){
        }

        this.getStaffType()
      })
    },
    getAttribute(){
      this.attributeList=[]
         this.$get('logistics','/product.attributes').then(result=>{
              this.attributeList=result.data
                
          })
    },
       delAttr(data){
       this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res=>{
          var url='/product.attributes/'+data.attribute_id
          this.$delete('logistics',url,{
            _method :'DELETE'
          }).then(res=>{
            this.$message({
              type:'success',
              message:'删除成功',
            })
            this.getAttribute()
          }).catch(error=>{
             this.$message({
              type:'error',
              message:error.message,
            })
          })
      })
    },
       // 保存新增商品属性  或 保存编辑商品属性
    saveAttr(){
      if(this.attributeList.length>5){
           this.$message({
          type:'error',
          message:'最多添加5条商品属性'
        })
      }
      if(this.attribute_name==''){
        this.$message({
          type:'error',
          message:'请输入属性名'
        })
        return
      }
      if(this.type=='add'){
        this.$post('logistics','/product.attributes',{
        attribute_name :this.attribute_name 
      }).then(res=>{
        this.dialogVisible=false
        this.getAttribute()
           this.$message({
          type:'success',
          message:'保存成功'
        })
        this.attribute_name =''
      }).catch(error=>{
        this.dialogVisible=false

          this.$message({
          type:'error',
          message:error.message
        })
      })
      }else{
        var url='/product.attributes/'+this.attribute_id
        this.$put('logistics',url,{
        attribute_name :this.attribute_name,
        _method:'PUT'
      }).then(res=>{
        this.dialogVisible=false
        this.getAttribute()
           this.$message({
          type:'success',
          message:'保存成功'
        })
        this.attribute_name =''
      }).catch(error=>{
        this.dialogVisible=false

          this.$message({
          type:'error',
          message:error.message
        })
      })
      }
    },
    // 编辑属性
        editAttr(data){
      this.attribute_name=data.attribute_name
      this.attribute_id=data.attribute_id
      this.dialogVisible=!this.dialogVisible
      this.type='edit'
    },
    // 获取员工类型
    getStaffType(){
      this.$get('logistics','/staffs.types').then(res=>{
        this.StaffType=res.data
      })
    },
    // 保存
    save(){
      var temp={}
      
      for (const key in this.form) {
        if (this.form.hasOwnProperty(key)) {

          if(this.form[key]===true){
             temp[key]=1
          }else  if(this.form[key]===false) {
            temp[key]=0
          }else{
            temp[key]=this.form[key]
          }
        }
      }
      this.$put('logistics','/configs.order',{
        _method :"PUT",
        ...temp
      }).then(res=>{
        this.$message({
          type:'success',
          message:'保存成功'
        })
      }).catch(error=>{
this.$message({
          type:'error',
          message:error.message
        })
      })
    },
    // 改变checkbox状态的时候
    changes(val){
      if(!this.form[val]){
          this.form[val+'_pay_type']=[]
      }
       if(val=='order_directly_dealer'&&!this.form[val]){
         this.form['order_price_directly_dealer']=0
      } 
     if(val=='order_not_directly_dealer'&&!this.form[val]){
       this.form['order_price_not_directly_dealer']=0
     }
     if(val=='order_model'&&this.form[val]==1){
       if(this.form.order_not_directly_shop_pay_type.indexOf('1')!=-1){
          this.form.order_not_directly_shop_pay_type=['1']
       }else{
          this.form.order_not_directly_shop_pay_type=[]
       }
        if(this.form.order_not_directly_dealer_pay_type.indexOf('1')!=-1){
          this.form.order_not_directly_dealer_pay_type=['1']
       }else{
          this.form.order_not_directly_dealer_pay_type=[]
       }
        
     }
   
    }
   
  },
  created(){
    this.init()
  },
  watch: {
    form: {
      handler(newValue, oldValue) {
        //执行操作
        if (newValue.order === "启用") {
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.tipsBox {
  background-color: #eee;
  width: 50%;
  padding: 5px;
  h6 {
    color: #000;
    font-weight: 600;
  }
}
.tips {
  color: #bbb;
  margin-left: 15px;
}
.error {
  color: #f04635;
}
.product {
  border: 1px solid #000;
  width: 60%;
  padding: 15px;
  ul {
    li {
      background-color: #eee;
      padding: 5px 10px;
      margin: 10px 0;
    }
  }
}
/deep/ .foot {
  text-align: center;
  /deep/ .el-button {
    display: inline-block;
  }
}
</style>

